import {
    Button,
    Card,
    CardContent,
    Divider,
    Grid,
    TextField,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    OutlinedInput,
    InputAdornment,
    CardActions,
    FormHelperText,
    CardHeader
} from '@mui/material';
import React from 'react';

let vehclassifications = require('./vehicleclass.json');

const VehicleFeetInput = (props) => {
    const defaultValue = props.defaultValue;
    const name = props.name;
    const id = name + "Ft";
    const setSelectedProfile = props.setSelectedProfile;
    const selectedProfile = props.selectedProfile;
    const [value, setValue] = React.useState(defaultValue);
    const [error, setError] = React.useState(value === 0);

    React.useEffect(() => {
        if (value === 0 || value === "") {
            setError(true);
        } else {
            setError(false);
            setSelectedProfile(selectedProfile => {
                selectedProfile[name]['feet'] = value;
                return {
                    ...selectedProfile,
                }
            })
        }
    }, [value])

    const handleChange = (event) => {
        const value = event.target.value;
        if (value !== "") {
            if (!isNaN(Number(value)) && Number(value) > 0) {
                setValue(Number(value))
            } else {
                setValue("");
            }
        } else {
            setValue("")
        }
    }

    React.useEffect(() => {
        setValue(selectedProfile[name].feet);
    }, [selectedProfile])

    return (
        <FormControl sx={{ width: '45%', marginTop: 1 }} variant="outlined">
            <OutlinedInput
                variant="outlined"
                onChange={handleChange}
                error={error}
                type="number"
                id={id}
                name={name}
                value={value}
                defaultValue={defaultValue}
                endAdornment={<InputAdornment position="end">ft</InputAdornment>}
                aria-describedby={name}
                inputProps={{
                    'aria-label': { name },
                }}
            />
            <FormHelperText error={error} id={name + "error"}>
                {error ? `Feet must be entered and larger than 0` : `Enter the height in feet of your vehicle`}
            </FormHelperText>
        </FormControl>
    )
}

const VehicleWeightInLbsInput = (props) => {
    const defaultValue = props.defaultValue;
    const name = props.name;
    const setSelectedProfile = props.setSelectedProfile;
    const selectedProfile = props.selectedProfile
    const [value, setValue] = React.useState(defaultValue);
    const [error, setError] = React.useState(value === 0);

    React.useEffect(() => {
        if (value === 0 || value === "") {
            setError(true);
        } else {
            setError(false);
            if (value != selectedProfile['weightInLbs']) {
                setSelectedProfile(selectedProfile => {
                    selectedProfile['weightInLbs'] = value;
                    return {
                        ...selectedProfile,
                    }
                })
            }
        }
    }, [value])

    const handleChange = (event) => {
        const value = event.target.value;
        if (value !== "") {
            if (!isNaN(Number(value)) && Number(value) > 0) {
                setValue(Number(value))
            } else {
                setValue("");
            }
        } else {
            setValue("")
        }
    }

    React.useEffect(() => {
        setValue(selectedProfile[name]);
    }, [selectedProfile])

    return (
        <FormControl sx={{ marginTop: 1 }} fullWidth variant="outlined">
            <OutlinedInput
                type="number"
                id={name}
                name={name}
                onChange={handleChange}
                error={error}
                value={value}
                endAdornment={<InputAdornment position="end">lbs</InputAdornment>}
                aria-describedby={name}
                inputProps={{
                    'aria-label': { name },
                }}
            />
            <FormHelperText error={error} id={name + "error"}>
                {error ? `Vehicle Weight must be entered and larger than 0` : `Enter the weight of your vehicle`}
            </FormHelperText>
        </FormControl>
    )
}

const VehicleInchesInput = (props) => {
    const defaultValue = props.defaultValue;
    const name = props.name;
    const id = name + "In";
    const setSelectedProfile = props.setSelectedProfile;
    const selectedProfile = props.selectedProfile
    const [value, setValue] = React.useState(defaultValue);
    const [error, setError] = React.useState(value < 0 || value > 11);

    React.useEffect(() => {
        if (value === "") {
            setError(true);
        } else {
            setError(false);
            if (value !== selectedProfile[name]['inches']) {
                setSelectedProfile(selectedProfile => {
                    selectedProfile[name]['inches'] = value;
                    return {
                        ...selectedProfile,
                    }
                })
            }
        }
    }, [value])

    const handleNumberChange = (event) => {
        const value = event.target.value;
        if (value !== "") {
            if (!isNaN(Number(value)) && Number(value) > -1 && Number(value) < 12) {
                setValue(Number(value))
            } else {
                setValue("");
            }
        } else {
            setValue("")
        }
    }

    React.useEffect(() => {
        setValue(selectedProfile[name].inches);
    }, [selectedProfile])

    return (
        <FormControl sx={{ width: '45%', marginLeft: 2, marginTop: 1 }} variant="outlined">
            <OutlinedInput
                variant="outlined"
                onChange={handleNumberChange}
                error={error}
                type="number"
                id={id}
                name={name}
                value={value.toString()}
                endAdornment={<InputAdornment position="end">in</InputAdornment>}
                aria-describedby={name}
                inputProps={{
                    'aria-label': { name },
                }}
            />
            <FormHelperText error={error} id={name + "error"}>
                {error ? "Inches must be between 0 and 11" : "Enter a number 0-11"}
            </FormHelperText>
        </FormControl>
    )
}

export const VehicleProfileDetails = (props) => {
    const selectedProfile = props.selectedProfile;
    const setSelectedProfile = props.setSelectedProfile;
    const editedProfile = props.editedProfile;
    const resetProfile = props.resetProfile
    const saveProfile = props.saveProfile;

    const handleTextChange = (event) => {
        var name = event.target.name;
        var value = event.target.value;
        console.log("handleTextChange: " + name + ", " + value);
        setSelectedProfile({
            ...selectedProfile,
            [event.target.name]: event.target.value
        })
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        const name = event.target.name;
        console.log("handleSelectChange: " + name + ", " + value);
        setSelectedProfile({
            ...selectedProfile,
            [event.target.name]: event.target.value
        })
    }

    const handleSubmit = (e, selectedProfile) => {
        e.preventDefault();
        saveProfile(selectedProfile);
    }

    return (
        <form
            autoComplete="off"
            onSubmit={(e) => handleSubmit(e, selectedProfile)}
        >
            <Card>
                <CardHeader title={selectedProfile?.isNew ? "Create New Vehicle" : selectedProfile.externalId} sx={{ paddingBottom: 2 }} />
                <CardContent>
                    <Grid
                        container
                        spacing={2}
                    >
                        {selectedProfile.isNew ? <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Vehicle Name"
                                name="externalId"
                                onChange={handleTextChange}
                                required={true}
                                defaultValue={selectedProfile.externalId}
                                variant="outlined"
                            />
                        </Grid> : null}
                        <Grid
                            item
                            md={6}
                            xs={12}
                        > <FormControl fullWidth required={true}>
                                <InputLabel id="vehicle-class-select-label">Vehicle Class</InputLabel>
                                <Select
                                    labelId="vehicle-class-select-label"
                                    id="vehicle-class-select"
                                    label="Select a Vehicle Class"
                                    value={selectedProfile.type}
                                    name="type"
                                    onChange={handleSelectChange}
                                >
                                    {vehclassifications.map(v => {
                                        return <MenuItem value={v.id} key={v.id}>{v.name}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Description"
                                name="description"
                                onChange={handleTextChange}
                                required={true}
                                value={selectedProfile.description}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <Typography
                                color="textPrimary"
                                variant="h6"
                            >
                                Vehicle Details
                            </Typography>
                        </Grid>

                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <Typography
                                color="textSecondary"
                                variant="subtitle"
                            >
                                Vehicle Height
                            </Typography><br />
                            <VehicleFeetInput defaultValue={selectedProfile.vehicleHeight.feet} name="vehicleHeight" setSelectedProfile={setSelectedProfile} selectedProfile={selectedProfile} />
                            <VehicleInchesInput defaultValue={selectedProfile.vehicleHeight.inches} name="vehicleHeight" setSelectedProfile={setSelectedProfile} selectedProfile={selectedProfile} />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <Typography
                                color="textSecondary"
                                variant="subtitle"
                            >
                                Vehicle Width
                            </Typography><br />
                            <VehicleFeetInput defaultValue={selectedProfile.vehicleWidth.feet} name="vehicleWidth" setSelectedProfile={setSelectedProfile} selectedProfile={selectedProfile}/>
                            <VehicleInchesInput defaultValue={selectedProfile.vehicleWidth.inches} name="vehicleWidth" setSelectedProfile={setSelectedProfile} selectedProfile={selectedProfile} />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <Typography
                                color="textSecondary"
                                variant="subtitle"
                            >
                                Vehicle Weight
                            </Typography><br />
                            <VehicleWeightInLbsInput defaultValue={selectedProfile.weightInLbs} name="weightInLbs" setSelectedProfile={setSelectedProfile} selectedProfile={selectedProfile} label={"Vehicle Weight"} />
                        </Grid>
                    </Grid>
                </CardContent>
                <Divider sx={{ marginTop: 1 }} />
                <CardActions sx={{ m: 1 }}>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={!editedProfile}
                    >
                        Save
                    </Button>
                    <Button
                        color="secondary"
                        variant="contained"
                        onClick={resetProfile}
                        disabled={!editedProfile}
                    >
                        Reset
                    </Button>
                </CardActions>
            </Card>
        </form >
    );
};


